import { motion } from 'framer-motion';

interface EquipmentCardProps {
  name: string;
  description: string;
  capabilities: string[];
  icon: string;
  image: string;
  index: number;
}

export default function EquipmentCard({
  name,
  description,
  capabilities,
  image,
  index,
}: EquipmentCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="group bg-white rounded-2xl overflow-hidden border border-charcoal-100 hover:shadow-xl transition-all"
    >
      <div className="aspect-video overflow-hidden bg-charcoal-100">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6">
        <h3 className="font-semibold text-xl text-charcoal-900 mb-2">{name}</h3>
        <p className="text-charcoal-600 text-sm leading-relaxed mb-4">
          {description}
        </p>
        <div className="flex flex-wrap gap-2">
          {capabilities.slice(0, 3).map((capability, idx) => (
            <span
              key={idx}
              className="px-3 py-1 bg-primary-50 text-primary-700 text-xs font-medium rounded-full"
            >
              {capability}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
